import { createContext, useContext, useEffect } from 'react';
import { useLocalStorageState } from '../hooks/useLocalStorageState';

const ColorModeContext = createContext();

const colorModes = {
  green: 'green-mode',
  purple: 'purple-mode',
};

function ColorModeProvider({ children }) {
  const [colorMode, setColorMode] = useLocalStorageState(
    colorModes.green,
    'colorMode',
  );

  useEffect(() => {
    document.documentElement.className = colorMode;
  }, [colorMode]);

  const toggleColorMode = () => {
    setColorMode((currentMode) =>
      currentMode === colorModes.green ? colorModes.purple : colorModes.green,
    );
  };

  return (
    <ColorModeContext.Provider
      value={{ colorMode, toggleColorMode, colorModes }}
    >
      {children}
    </ColorModeContext.Provider>
  );
}

function useColorMode() {
  const context = useContext(ColorModeContext);

  if (context === undefined)
    throw new Error('ColorModeContext was used outside of ColorModeProvider');

  return context;
}

export { ColorModeProvider, useColorMode };
